import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 640 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M174.2 111.2 320 49.4 503 127c5.9 2.5 9.1 7.8 9 12.8-.3 52.8-13 127.8-52.2 195.3zM497.9 365c47.4-78.8 61.8-166.3 62.1-225 .1-26.2-16.3-47.9-38.3-57.2L333.4 2.9C329.2 1 324.7 0 320 0s-9.2 1-13.4 2.9L131 77.4 38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7zM80.6 159.5c5.5 102 51.5 266.3 213.1 343.7 16.7 8 36.1 8 52.8 0 35.7-17.1 65.8-38.5 91.1-62.5l-38.2-30.1c-20.8 18.9-45.1 35.7-73.5 49.3-3.6 1.7-7.8 1.7-11.3 0C195.8 403.1 147.9 290.6 133.3 201z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }